module.exports = __webpack_public_path__ + "img/rando.2e65ffd3.svg";